export const FIELD_NAME_FIELD_NAME = 'name';

export const TEST_ID = 'updateFieldForm';
